import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var ArrowDownIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 16 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsx(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M.48 7.46a.75.75 0 0 1 1.06.019l5.71 5.914V.75a.75.75 0 0 1 1.5 0v12.643l5.71-5.914a.75.75 0 0 1 1.08 1.042l-6.998 7.247a.748.748 0 0 1-1.085-.001L.46 8.52a.75.75 0 0 1 .02-1.06Z"
        })
    }));
};
